import React, { FC } from 'react'
import Button from 'components/Common/Button'
import ToolTip from 'components/Common/ToolTip'

import { PlacesType } from 'react-tooltip'
import { FontSize, FontWeight } from 'types'
import { AppLabelWrapper } from '../AppFormFields/AppCommonStyles/AppFormField.style'

interface IAppToolTipWithButton {
  label?: string
  toolTipText?: string
  toolTipWidth?: string
  labelFontSize?: FontSize
  toolTipPlace?: PlacesType
  fontWeight?: FontWeight
  toolTipClass?: string
  toolTipOpacity?: number
  toolTipBackgroundColor?: string
}

export const AppToolTipWithButton: FC<IAppToolTipWithButton> = ({
  label,
  labelFontSize,
  toolTipText,
  toolTipWidth,
  toolTipPlace,
  fontWeight,
  toolTipClass,
  toolTipOpacity,
  toolTipBackgroundColor,
}) => {
  return (
    <div className="flex items-center gap-2">
      {label && <AppLabelWrapper>{label}</AppLabelWrapper>}

      {label && toolTipText && (
        <ToolTip
          name={label}
          text={toolTipText}
          width={toolTipWidth}
          place={toolTipPlace}
          className={toolTipClass}
          opacity={toolTipOpacity}
          backgroundColor={toolTipBackgroundColor}
        >
          <Button
            variant="text"
            leftIcon="tool-tip"
            className="!p-0 focus:!border-0 w-full"
            type="button"
          />
        </ToolTip>
      )}
    </div>
  )
}
